import PropTypes from 'prop-types';
import { Card, Accordion, Col } from 'react-bootstrap';
import useFormatter from "../hooks/useFormatter";
import { messages as jobmessages } from '../views/Job/Job.messages';

const PaymentDetails = (props) => {
    const { formatCurrency } = useFormatter();
    const lng = props.intl.formatMessage;
    const statusCode = props.job?.statuscode;

    // helper for getting values from job or subjob
    const getValue = (field) => {
        if (props.subjob !== undefined) {
            return formatCurrency(props.subjob[field], props.subjob.currency);
        } else if (props.job !== undefined) {
            return formatCurrency(props.job[field], props.job.currency);
        }
        return '';
    }

    // IL invoices only need to show the original amount
    if (statusCode === 300) {
        return (
            <li className='invoice-summary-orignal-amount'>
                <span className='label'>{lng(jobmessages.originalSum)}</span>
                <span className='float-end'>{formatCurrency(props.openamount, props.job?.currency)}</span>
            </li>
        )
    } else if (statusCode === 104) {
        // Credit invoice
        return (
            <li className='invoice-summary-orignal-amount'>
                <span className='label'>{lng(jobmessages.openTotal)}</span>
                <span className='float-end'>
                    {formatCurrency((props.job?.modoverpaidamount ?? 0) * -1, props.job?.currency)}
                </span>
            </li>
        )
    }

    // payment details, ie. all fees related to the invoice / subjob
    return (
        <li className='invoice-summary-opentotal accordion-listitem'>
            <Accordion flush>
                <Accordion.Item eventKey='paymentdetails'>
                    <Accordion.Header as="text" aria-label={lng(jobmessages.showDetails)}
                        id="paymentdetails-header"
                        title={lng(jobmessages.showDetails)}
                    >
                        <Col as="span">
                            <span className='label'>
                                {lng(jobmessages.openTotal)}
                            </span>
                        </Col>
                        <Col as="span" className='float-end text-end pe-2 pe-lg-3'>
                            {formatCurrency(props.openamount, props.job?.currency)}
                        </Col>
                    </Accordion.Header>
                    <Accordion.Body className='pe-0 pb-0'>
                        <Card className={'fullwidth-mobile no-box-shadow p-0 mb-0'}>
                            <Card.Body className='p-0'>
                                <ul className='list-unstyled' aria-labelledby="paymentdetails-header">
                                    <li id='paymentdetails-openamount'>
                                        <span className='text-muted'>{lng(jobmessages.openTotal)} </span>
                                        <span
                                            className='float-end text-end text-muted'
                                            aria-live='polite'
                                        >
                                            {getValue('openamount')}
                                        </span>
                                    </li>
                                    <li id='paymentdetails-opencapital'>
                                        {lng(jobmessages.openCapital)}
                                        <span
                                            className='float-end text-end'
                                            aria-live='polite'
                                        >
                                            {getValue('opencapital')}
                                        </span>
                                    </li>
                                    <li id='paymentdetails-openexpenses'>
                                        {lng(jobmessages.openExpenses)}
                                        <span
                                            className='float-end text-end'
                                            aria-live='polite'
                                        >
                                            {getValue('openexpenses')}
                                        </span>
                                    </li>
                                    <li id='paymentdetails-openinterest'>
                                        {lng(jobmessages.lateInterest)}
                                        <span
                                            className='float-end text-end'
                                            aria-live='polite'
                                        >
                                            {getValue('openinterest')}
                                        </span>
                                    </li>
                                    {props.subjob === undefined && props.job.paidamount !== undefined && (
                                        <li id='paymentdetails-paidamount'>
                                            {lng(statusCode === 122 ?  jobmessages.paidProcessing : jobmessages.paid)}
                                            <span
                                                className='float-end text-end'
                                                aria-live='polite'
                                            >
                                                {getValue('paidamount')}
                                            </span>
                                        </li>
                                    )}
                                </ul>
                            </Card.Body>
                        </Card>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </li>
    );
};

PaymentDetails.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
    'subjob': PropTypes.object,
    'openamount': PropTypes.number
};

export default PaymentDetails;